exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".industry-big-list-container{margin-top:25px}.header-image-container.industries-header{-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-direction:row;flex-direction:row}.header-image-container.industries-header img{margin:2% 4% 2% 2%;width:20%;height:auto;-ms-flex-preferred-size:33%;flex-basis:33%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/routes/industries.styl
// module id = 494
// module chunks = 0